import { EpimsBaseEntityDto } from './epim-base.dto';

export class PLStakeholderMatrixRaciDto extends EpimsBaseEntityDto{
  PLStakeholderMatrixId: string;
  RaciId: string;
  TemplateId: string;
  SubscriptionUserId: string;
  HierarchyName: string;
  PipelineLicenceRequestId: string;
  }
